import { render, staticRenderFns } from "./promotion-viewer-dialog.vue?vue&type=template&id=85dfce3e&scoped=true"
import script from "./promotion-viewer-dialog.vue?vue&type=script&lang=js"
export * from "./promotion-viewer-dialog.vue?vue&type=script&lang=js"
import style0 from "./promotion-viewer-dialog.vue?vue&type=style&index=0&id=85dfce3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dfce3e",
  null
  
)

export default component.exports